<template>
  <div class="main">
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun"
          >查询</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-row-click="$emit('obj', $event)"
      @on-selection-change="selectData = $event"
    >
      <AddressList
        slot-scope="{ row, index }"
        slot="addressS"
        :list="row.addressS"
        :readonly="true"
        :noUpdate="true"
      ></AddressList>
      <AddressList
        slot-scope="{ row, index }"
        slot="addressD"
        :list="row.addressD"
        :readonly="true"
        :noUpdate="true"
      ></AddressList>
      <template slot-scope="{ row, index }" slot="action">
        <!-- <Button size="small" @click="openUpdateStatus(row, index)">提货</Button> -->
        <Button size="small" @click="openUpdateDispatchStatus(row, index)"
          >调度</Button
        >
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <Button v-if="checkMore" @click="$emit('objs', selectData)" type="success"
        >我选好了</Button
      >
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
  </div>
</template>
<script>
var list1 = [],
  list2 = [];
export default {
  props: ["scan", "checkMore", "status", "col"],
  data() {
    return {
      columns: [
        {
          type: "selection",
          width: 70,
          align: "center",
          tooltip: true,
          noTable: this.checkMore != true,
        },
        /* {
          title: "提货状态",
          key: "status2", //0--/未入仓 1--已入仓
          sort: 1.1,
        }, */
        {
          title: "调度单号",
          key: "no",
          sort: 1.1,
        },
        {
          title: "调度状态",
          key: "dispatchStatus2", //0--/待提货 1--已调度
          sort: 1.2,
        },
        {
          title: "操作",
          slot: "action",
          sort: 100,
          width: 150,
          align: "center",
          fixed: "right",
        },
      ],
      forms: [
        /* {
          title: "提货单号",
          key: "no",
          required: false,
          type: "Select",
          selectItems: ["HS202305061112"],
        }, */
        {
          title: "订单号",
          key: "listOrders",
          key2: "listOrders2",
          slotForm: "ono",
          required: true,
          span: 24,
        },
        {
          title: "业务类型",
          key: "bpMode",
          key2: "bpMode2",
          required: true,
          type: "Select",
          selectType: "obj",
          selectItems: this.lydic["bpMode"],
          span: 8,
        },
        {
          title: "车牌号",
          key: "carId",
          key1: "carNo",
          required: false,
          type: "selectCar",
          span: 8,
        },
        {
          title: "司机",
          key4: "driverAccount",
          key1: "driver",
          //key3: "driverAccount",
          required: false,
          type: "selectUser",
          span: 8,
        },

        {
          title: "提货城市",
          key: "addressS",
          keyX: "xs",
          keyY: "ys",
          slot: "addressS",
          required: true,
          readonly: false,
          noUpdate: true,
          width: 300,
          type: "AddressList",
          span: 8,
          list1,
          list2,
        },
        {
          title: "卸货城市",
          key: "addressD",
          slot: "addressD",
          keyX: "xd",
          keyY: "yd",
          width: 300,
          required: true,
          readonly: false,
          noUpdate: true,
          type: "AddressList",
          span: 8,
          list1,
          list2,
        },
        {
          title: "提货时间",
          key: "timeS",
          key2: "timeS2",
          required: true,
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "卸货时间",
          key: "timesUnload",
          key2: "timesUnload2",
          required: true,
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },

        {
          title: "装货到场时间",
          key: "timesLoadArrive",
          key2: "timesLoadArrive2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "装货离开时间",
          key: "timesLoadLeave",
          key2: "timesLoadLeave2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "卸货到场时间",
          key: "timesUnloadArrive",
          key2: "timesUnloadArrive2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "卸货离开时间",
          key: "timesUnloadLeave",
          key2: "timesUnloadLeave2",
          type: "lyyymmdd",
          formate: "datetime",
          span: 8,
        },
        {
          title: "备注",
          key: "remark",
          required: false,
          type: "Input",
          span: 8,
        },
      ],
      tableData: [],

      searchItem: {
        pageNumber: 1,
        pageSize: 50,
        startTime: "",
        endTime: "",
        no: "",
        keyWork: "",
        customer: "",
        customerNo: "",
        addressD: "",
        addressS: "",
        //status: 0, //订单状态(0 订单确认，1 上门提货 2 提货已完成，3-待配载,4- 已配载 5-待发车，6-已发车，7 在途中，8 已过关，9 已送达香港仓库,10 同城配送, 11未签收,12 已签收,13 客户退货)
        //bpMode: true,
        carType: "",
        tradeType: "",
        deliveryMode: "",
        //status:[0,1,2,3,4,5]
      },
      searchForms: [
        {
          title: "订单号",
          key: "ono",
          type: "Input",
        },

        {
          title: "交货方式",
          key: "deliveryMode",
          required: false,
          type: "Select",
          selectItems: ["派送", "提货", "自提", "自送", "存仓"],
        },
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      total: 0,
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-ctc/pickup/listDispatch",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].dispatchStatus2 = this.lydic.getVal(
            "dispatchStatus",
            data[i].dispatchStatus
          );
          data[i].status2 = this.$t("rucang." + data[i].status);
          data[i].timeS2 = this.utils.time(data[i].timeS, "yymmddhhmm");
          data[i].timesUnload2 = this.utils.time(
            data[i].timesUnload,
            "yymmddhhmm"
          );
          data[i].timesLoadArrive2 = this.utils.time(
            data[i].timesLoadArrive,
            "yymmddhhmm"
          );
          data[i].timesLoadLeave2 = this.utils.time(
            data[i].timesLoadLeave,
            "yymmddhhmm"
          );
          data[i].timesUnloadArrive2 = this.utils.time(
            data[i].timesUnloadArrive,
            "yymmddhhmm"
          );
          data[i].timesUnloadLeave2 = this.utils.time(
            data[i].timesUnloadLeave,
            "yymmddhhmm"
          );
          data[i].listOrders2 = ordes(data[i].listOrders);
          data[i].bpMode2 = this.lydic.getVal("bpMode", data[i].bpMode);
        }
        this.tableData = data;

        function ordes(t) {
          var arr = [];
          for (let i = 0; i < t.length; i++) {
            arr.push(t[i].ono);
          }

          return arr.join(",");
        }
      });
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
  },
  mounted() {
    var config = {
      min: 130,
      max: 300,
    };
    this.columns = this.utils.cols(this.forms, this.columns, config);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 200);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/fahuo/shangmentihuoList.vue